/*
  ==========================================
   Document ready
  ==========================================
*/
document.addEventListener("DOMContentLoaded", function (event) {
  //---===>>> on screen effect
  Array.from(document.getElementsByClassName("on-screen")).forEach((item) => {
    // item.style.backgroundColor = "blue";

    // const observer = new window.IntersectionObserver(([entry]) => {
    //   if (entry.isIntersecting) {
    //     item.classList.add("is-screened");
    //     return
    //   }
    //   // item.classList.remove("is-screened");
    // }, {
    //   root: null,
    //   threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
    // })
    // observer.observe(item);

    const hideWhenBoxInView = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) {
        // If not in view
        // item.classList.remove("is-screened");
      } else {
        item.classList.add("is-screened");
      }
    });
    hideWhenBoxInView.observe(item);
  });

  // document.getElementByClassName("menu-item-has-children").click(function (event) {
  //   event.stopPropagation();
  //   this.find(".dropdown-menu").classList.toggle("open");
  // });
}); // ** end document ready **

// Dropdown menu toggle .open class
let dropdownMenus = document.querySelectorAll(".menu-item-has-children");

dropdownMenus.forEach((dropdownMenu) => {
  dropdownMenu.addEventListener("click", function (event) {
    dropdownMenu.querySelector(".dropdown-menu").classList.toggle("open");
  });
});

/*
  ==========================================
   Menu Slider on Btn Click
  ==========================================
*/
function activeMenu() {
  var menuBtn = document.getElementById("hamburger-menu");
  menuBtn.classList.toggle("open");
  document.getElementById("navigation-menu").classList.toggle("active");
  document.querySelector("body").classList.toggle("overflow-hidden");
}

/*
  ==========================================
  selector Menu on Click
  ==========================================
*/
const selectorMenu = document.querySelector(".select-state--click");
if (selectorMenu === null) {
  // console.log(".select-state-click not found on this page");
} else {
  selectorMenu.addEventListener("click", function handleClick() {
    document
      .querySelector(".select-state--click .navbar-nav")
      .classList.toggle("active");
  });
}

// Add target blank to esyohform to open new tab on submit
const esyohForm = document.querySelector(".zip_widget_esy_container form");
esyohForm.setAttribute("target", "_blank");

const esyohFormSubmitButton = document.querySelector(
  ".zip_widget_esy_container form input[type=submit]"
);

// On form submit open modal-box
esyohFormSubmitButton.addEventListener("click", () => {
  document.querySelector(".modal-box").style.display = "flex";
});

// Close modal-box
const closeButton = document.querySelector(".modal-box .close");

closeButton.addEventListener("click", () => {
  document.querySelector(".modal-box").style.display = "none";
});
